export default "__VITE_ASSET__fa50ecf2__"